<template>
    <div class="user-credit">
        <div class="title-header">
            <p>ADD CREDITS</p>
        </div>
        <!-- <div class="container-fluid"> -->
                    <div class="card-deck">
                        <div class="cards"
                            v-for="credit in credits" 
                            :key="credit"
                            >
                            <div class="card mt-5">
                                <div class="card-body">
                                    <h4 class="card-title">{{credit.title}}</h4>
                                    <h4 class="card-text">{{credit.text}}</h4>
                                    <p class="card-description">{{credit.description}}</p>
                                    <a href="#" class="btn btn-primary mt-2">ADD TO CART</a>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row"> -->
                        <!-- </div> -->
                    </div>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    name: "add-credit",
    data() {
        return{
            credits: [
                {'id':'1','title':'10 credits', 'text':'USD 1.00', 'description':'USD 1.00 per credit'},
                {'id':'2','title':'15 credits', 'text':'USD 0.80', 'description':'USD 0.80 per credit'},
                {'id':'3','title':'20 credits', 'text':'USD 0.70', 'description':'USD0.70 per credit'},
                {'id':'1','title':'10 credits', 'text':'USD 1.00', 'description':'USD 1.00 per credit'},
                {'id':'2','title':'15 credits', 'text':'USD 0.80', 'description':'USD 0.80 per credit'},
                {'id':'3','title':'20 credits', 'text':'USD 0.70', 'description':'USD0.70 per credit'},     
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
    .user-credit{
        .title-header{
            color: #58595b;
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 40px;
        }
        .card{
            width: 18rem;
            box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
            transition: 0.3s;
            .card-title{
                padding-top: 24px;
                font-size: 18px;
                color: #58595B;
            }
            .card-text{
                margin-top: 29px;
                font-size: 18px;;
                color: #58595B;
            }
            .card-description{
                font-size: 12px;
                color: #B9B9B9;
                line-height: 0.5;
            }
        }

        @media screen and (max-width: 320px) {
            
        }
    }
</style>